export default class AuthTreeError extends Error {
  constructor(message, step, code = null) {
    super(message);
    this.step = step;
    this.code = code;
  }
}
